import EmailPasswordAuthentication from '@/core/pages/Auth/EmailPasswordAuthentication';
import PhoneAuthentication from '@/core/pages/Auth/PhoneAuthentication';
import { useTypedSelector } from '@/core/redux/hooks';
import { getSetting } from '@/core/redux/selectors/settingsManagement.selectors';
import { SettingsKeys } from '@/core/enums';
import EmailAuthentication from '@/core/pages/Auth/EmailAuthentication';
import { LoginSettings } from '@/core/types';

const Login = () => {
  const loginSettings = useTypedSelector((state) =>
    getSetting<LoginSettings>(state, SettingsKeys.LOGIN),
  );

  if (loginSettings?.emailOTP) {
    return <EmailAuthentication />;
  }

  if (loginSettings?.phone) {
    return <PhoneAuthentication />;
  }

  return <EmailPasswordAuthentication />;
};

export default Login;
